<template>
    <FloatingPanel>
        <div class="map-canvas-blocks-modules-map-BlockPanel">
            <div class="m-5 text-sm text-gray-600">
                Deze block toont alle locaties uit de Kaart module.
            </div>

            <div slot="Algemeen">
                <CommonInputs :options="options" />
            </div>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";

export default {
    extends: AbstractPanel,
    components: {
        FloatingPanel,
        CommonInputs,
    },
};
</script>
